<template>
  <div class="d-flex flex-wrap gap-1">
    <GuBadge v-for="attr in attributes" :key="attr" variant="secondary" pill>
      {{ attr }}
    </GuBadge>
  </div>
</template>

<script setup>
import { computed } from 'vue'

import { GuBadge } from '@shared/gu-components/badge'

const props = defineProps({
  params: {
    type: Object,
    default: () => ({}),
  },
})

const attributes = computed(() => {
  const value = props.params.data?.Attributes
  return Array.isArray(value) ? value : []
})
</script>
